import type { LinksView } from "@shared/site-audit-report-view";
import { ReportSection } from "./section";

export function LinksSection({ links }: { links: LinksView }) {
  return (
    <ReportSection id="links" title="Links" hint="No referring-domain trend is stored for this run.">
      {links.state === "empty" ? (
        <p className="text-sm text-foreground/75">{links.emptyLabel}</p>
      ) : (
        <>
          <dl className="grid grid-cols-2 gap-3 lg:grid-cols-4">
            <Figure label="Backlinks" value={links.backlinks} />
            <Figure label="Referring domains" value={links.referringDomains} />
            <Figure label="Nofollow domains" value={links.nofollowReferringDomains} />
            <Figure label="Broken backlinks" value={links.brokenBacklinks} problem={links.brokenTone === "problem"} />
          </dl>
          {links.anchors.length > 0 ? (
            <ul className="space-y-2">
              {links.anchors.map((anchor) => (
                <li key={anchor.anchor} className="space-y-1">
                  <div className="flex justify-between gap-3 text-sm">
                    <span>{anchor.anchor}</span>
                    <span className="tabular-nums">{anchor.countLabel}</span>
                  </div>
                  <div className="h-2 rounded-full bg-muted" aria-hidden="true">
                    <div className="h-2 rounded-full bg-foreground/50" style={{ width: `${Math.round(anchor.bar * 100)}%` }} />
                  </div>
                </li>
              ))}
            </ul>
          ) : null}
        </>
      )}
    </ReportSection>
  );
}

function Figure({ label, value, problem = false }: { label: string; value: string | null; problem?: boolean }) {
  return (
    <div className="rounded-[0.75rem] border border-border px-3 py-2">
      <dt className="text-xs text-foreground/75">{label}</dt>
      <dd className={`mt-1 font-mono text-lg font-semibold tabular-nums ${problem ? "text-destructive" : ""}`}>
        {value}
        {problem ? <span className="ml-2 font-sans text-xs font-medium">Broken</span> : null}
      </dd>
    </div>
  );
}
